import { Injectable } from '@angular/core';

// Services
import { ServiceBase } from '../service-base';

const CLASS_NAME = 'JournalType';
const ENDPOINT = `/journal-types/`;

@Injectable({
    providedIn: 'root'
})
export class JournalTypeService extends ServiceBase {
    constructor() {
        super(CLASS_NAME, ENDPOINT);
    }
}
